import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="flex items-center gap-2.5 font-display text-xs font-bold uppercase tracking-[0.22em] text-orange2">
    <span aria-hidden="true" className="h-2 w-2 rounded-full bg-orange2" />
    {children}
  </p>
);
